import styled from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';

import { ButtonWrapper } from 'components/base/Dropdown/shared/styles';
import { MenuButton } from 'components/base/Menu/index';
import Layout from 'components/styled/Layout/Layout';
import {
  WhiteBlock,
  Toolbar,
  ToolbarMenu,
} from 'components/utility/GenericComponent/GenericComponent';
import { DropdownListWrapper } from 'components/styled/DropdownList/DropdownList';
import { ComponentTitle } from 'styles/global/typography/typography';
import {
  DataList,
  DataListItem,
} from 'components/DataToggleList/DataToggleList';

export const ControlsContainer = styled('div')`
  @media screen and (min-width: 48em) {
    padding-left: 3.5rem;
  }
  ${DataList} {
    @media screen and (min-width: 32.4375em) {
      @supports (grid-gap: 1em) and (grid-template-columns: repeat(4, 1fr)) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }
  ${DataListItem} {
    @media screen and (min-width: 32.4375em) {
      align-self: start;
    }
  }
`;

export const VisiblePeriodBox = styled('div')`
  order: 3;
  @media screen and (min-width: 48em) {
    flex-grow: 1;
  }
  @media screen and (min-width: 50em) {
    order: -1;
    margin-left: 0 !important;
  }
`;

export const PeriodDropdownWrapper = styled('div')`
  ${MenuButton} {
    font-family: 'Open Sans';
    font-size: ${modularScale(-1)};
  }
  ${ButtonWrapper} {
    padding: ${({ theme }): string =>
      `${theme.spacing.medium} ${theme.spacing.large}`};

    @media screen and (min-width: 48em) {
      padding: ${({ theme }): string =>
        `${theme.spacing.xsmall} ${theme.spacing.medium}`};
    }
  }
`;

export const GenericComponentWrapper = styled('section')<any>`
  @media screen and (min-width: 40em) {
    margin: ${({ theme }): string => `${theme.spacing.medium} auto`};
  }
  & > section {
    @media screen and (min-width: 60em) {
      ${Layout.MaxWidth} {
        width: 100% !important;
      }
    }
  }

  ${WhiteBlock} {
    @media screen and (min-width: 40em) and (max-width: 799px) {
      margin: ${({ theme }): string => `0 ${theme.spacing.medium}`};
      width: auto;
    }
    @media screen and (min-width: 50em) {
      margin: 0 auto;
    }
    ${Layout.MaxWidth} {
      @media screen and (min-width: 60em) {
        width: 100%;
      }
    }
    ${ToolbarMenu} {
      transform: none;
    }
    ${DropdownListWrapper} {
      min-width: 14.5em;
    }
    ${ComponentTitle} {
      font-size: 1.25em;
      margin-bottom: 0.3em;
      @media screen and (min-width: 40em) {
        font-size: 1.5em;
      }
    }
    ${Toolbar} {
      @media screen and (min-width: 40em) {
        padding: ${({ theme }): string =>
          `${theme.spacing.xlarge} 0 ${theme.spacing.small} 0`};
      }
    }
`;

export const ChartWrapper = styled('div')`
  @media screen and (min-width: 50em) {
    margin-bottom: -1em;
  }
`;
